import { Clock } from './Clock';
export class ReplayClock extends Clock {
    timeAt(perfTime) {
        return perfTime / 1000;
    }
    _end() {
        return Promise.resolve(0);
    }
    _pause() {
        return Promise.resolve(0);
    }
    _resume() {
        return Promise.resolve(0);
    }
    _seek(time) {
        return Promise.resolve(0);
    }
    close() {
    }
    get isRunning() {
        return false;
    }
    get now() {
        return 0;
    }
}
//# sourceMappingURL=ReplayClock.js.map